import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import { forgotPassword } from '../api/api';
import { useNavigate } from 'react-router-dom';

const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email').required('Email is required')
});

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                // Add API call here
                setLoading(true);
                const res = await forgotPassword(values);
                toast.success(res.message);
                // Reset form
                formik.resetForm();
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }

        },
    });

    return (
        <div className="min-h-screen flex md:flex-row">
            {/* Left: Form */}
            <div className="md:w-1/2 w-full bg-[#212121] text-white py-[25px] px-[25px] sm:px-[50px] lg:px-[91px] lg:py[25px]  flex flex-col justify-center block">
                <div className="mb-6 text-center">
                    <img src='./logo-transparent-png.png' alt="Logo" className="mx-auto w-[50%]" />
                </div>

                <form onSubmit={formik.handleSubmit} className="space-y-4">

                    {/* Email */}
                    <div>
                        <h3 className="font-bold text-center text-white">Forgot your password?</h3>
                        <p className="text-white text-center my-2 text-sm">
                            Don’t worry, we’ll help you reset it. Just enter your email below.
                        </p>
                        <label className="text-sm block mb-1 text-left">Email</label>
                        <input
                            type="email"
                            name="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            placeholder="Enter email"
                        />
                        {formik.touched.email && formik.errors.email && (
                            <p className="text-red-400 text-sm mt-1 text-left">{formik.errors.email}</p>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-teal-500 hover:bg-teal-600 text-white py-2 rounded mt-4"
                        disabled={loading}
                    >
                        Send
                    </button>
                    {/* Footer */}
                    <div className="mt-6 text-sm text-center text-gray-400 space-y-1 flex justify-end items-baseline">
                        {/* <p>613-720-5021</p>
                        <p>|</p>
                        <p>Have a question?</p>
                        <p>|</p> */}
                        <p><span className="text-teal-400 underline cursor-pointer hover:text-teal-500" onClick={() => navigate('/member-login')}>
                            Member Login
                        </span></p>
                    </div>
                </form>

            </div>

            {/* Right: Image */}
            <div className="md:w-1/2 w-full bg-gray-100 flex justify-center hidden md:block">
                <img
                    src="/parking-image.png"
                    alt="Parking"
                    className="w-full h-full object-cover"
                />
            </div>
            <ToastContainer
                closeButton={false}
                autoClose={5000}
                position='top-right'
            />
        </div>
    );
};

export default ForgotPassword;
